import { useState } from 'react';
import { ChevronDownIcon, ChevronRightIcon } from '@heroicons/react/16/solid';

interface FormulaAccordionProps {
  children: React.ReactNode;
  label?: string;
}

export function FormulaAccordion({ children, label = 'View formula details' }: FormulaAccordionProps) {
  const [open, setOpen] = useState(false);

  return (
    <div className="my-4">
      <button
        type="button"
        onClick={() => setOpen(prev => !prev)}
        className="flex items-center gap-1.5 text-xs font-medium text-gray-500 hover:text-gray-700 transition-colors group"
        aria-expanded={open}
      >
        {open ? (
          <ChevronDownIcon className="w-3.5 h-3.5 flex-shrink-0" />
        ) : (
          <ChevronRightIcon className="w-3.5 h-3.5 flex-shrink-0" />
        )}
        <span className="border-b border-dashed border-gray-300 group-hover:border-gray-500 transition-colors">
          {open ? 'Hide formula' : label}
        </span>
      </button>

      {open && (
        <div className="mt-3 p-4 bg-gray-50 rounded-lg border border-gray-200 overflow-x-auto">
          {children}
        </div>
      )}
    </div>
  );
}
